<template>
  <v-content class="gb">
    <div class="back-container" style="max-width: 1222px !important; margin: 0 auto">
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <div class="custom-position-back">
            <v-btn
                rounded
                depressed
                class="back-btn"
                @click="$router.push('/vendor/users')"
            >
              <img :src="require('@/assets/img/back.svg')" class="mr-2"/>
              back
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <v-card :loading="status === 'loading'" class="fill-width card-theme vendor-add-users">
            <v-row align="center" class="flex-colum">
              <v-col lg4 xs12 style="padding: 0!important;">
                <h2 class="azul medium-font main-title">Add New User</h2>
              </v-col>
              <v-col lg8 xs12 style="text-align: end;">
                <v-btn
                    rounded
                    depressed
                    class="px-6 ml-auto btn-blanco btn-blanco--a btn-white-add"
                    style="text-transform: capitalize;"
                    @click="addNewVendor"
                >+ Add New User
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <ValidationObserver ref="validator" v-slot="{  }">
              <v-data-table
                  :headers="headers"
                  :items="users"
                  item-key="id"
                  :hide-default-footer="true"
                  class="table-users"
              >
                <template v-slot:item="{ item }">
                  <tr :data-id="item.id">
                    <td>
                      <ValidationProvider
                          ref="first_name"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="item.first_name"
                            :error-messages="errors"
                            label="First Name"
                            name="first_name"
                            type="text"
                            required
                            class="ui-label change_bord especial_border custom-input-position-text label-medium"
                        ></v-text-field>
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider
                          ref="last_name"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="item.last_name"
                            :error-messages="errors"
                            label="Last Name"
                            name="last_name"
                            type="text"
                            required
                            class="ui-label change_bord especial_border custom-input-position-text label-medium"></v-text-field>
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider
                          ref="email"
                          rules="required|email"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="item.email"
                            :error-messages="errors"
                            label="Email"
                            name="email"
                            type="text"
                            required
                            class="ui-label change_bord especial_border custom-input-position-text label-medium"></v-text-field>
                      </ValidationProvider>
                    </td>
                    <td>
                      <ValidationProvider
                          ref="phone"
                          rules="required|size:10"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="item.phone"
                            :error-messages="errors"
                            label="Cell Phone"
                            name="phone"
                            type="text"
                            required
                            v-mask="mask"
                            class="ui-label change_bord especial_border custom-input-position-text label-medium"></v-text-field>
                      </ValidationProvider>
                    </td>
                    <td>
                      <div class="group text-center pa-2">
                        <div class="ct-add-users label-tooltip">
                          <label class="label-admin">Admin Access</label>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                                <span v-on="on" class="post-label">
                                                  <img :src="require('@/assets/info.png')" alt="help"
                                                       class="info-tooltip"/>
                                                </span>
                            </template>
                            <span class="content_modal">
                                                Admin Panel access will allow the user to
                                                <br/>manage billing information, add/remove
                                                <br/>users & vendors, view reports and manage
                                                <br/>the account.
                                            </span>
                          </v-tooltip>
                        </div>
                        <v-checkbox
                            class="chk custom-check-box custom-check-box-form"
                            v-model="item.is_admin"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td>
                                        <span @click="removeItem(item)" class="remove-data">
                                                          <img :src="require('@/assets/img/close_red.svg')"/>
                                        </span>
                    </td>
                  </tr>
                  <tr v-if="item.error">
                    <td colspan="5">
                      <v-alert border="top" color="red lighten-2" dark>{{ item.error }}</v-alert>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <v-card-text class="px-5 remove-paddings">
                <div class="pl-7">
                  <ValidationProvider
                      name="terms"
                      ref="terms"
                      rules="required-check"
                      v-slot="{ errors }"
                  >
                    <v-checkbox
                        v-model="agree_terms"
                        :error-messages="errors"
                        required
                        class="label-checkbox-vendor custom-check-box c-check"
                    >
                      <div
                          slot="label"
                          class="terms-privacy-agreement"
                          style="color: #061d47;"
                      >
                        I understand that upon clicking submit, the users listed above will
                        receive email and text notifications granting them access to sign up
                        under my account.

                      </div>
                    </v-checkbox>
                  </ValidationProvider>
                  <div class="text-center mt-12">
                    <v-btn
                        depressed
                        rounded
                        class="ml-6 btn-azul"
                        @click="submit"
                        style="margin: 53px auto 0px !important;"
                        :loading="status === 'loading'"
                        :disabled="status === 'loading'"
                    >ACCEPT
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
      <declined-modal :show="showDeclinedModal" :hide="hideDeclinedModal"/>
      <success-modal :show="showSuccessModal" :hide="hideSuccessModal"/>
    </v-container>
  </v-content>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import declinedModal from "./modals/declined";
  import successModal from "./modals/success";
  import {mask} from "vue-the-mask";
  import {mapState} from "vuex";

  export default {
    name: "AddUsers",
    created() {
      this.$store.dispatch('Banner/show');
      this.addNewVendor();
    },
    directives: {
      mask
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      "declined-modal": declinedModal,
      "success-modal": successModal,
    },
    computed: {
      ...mapState({
        status: (state) => state.Vendor_users_add_user.status,
      }),
    },
    data() {
      return {
        mask: "### - ### - ####",
        showDeclinedModal: false,
        showSuccessModal: false,
        users: [
          {
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            is_admin: false,
          }
        ],
        coupon_code: "",
        agree_terms: false,
        agree_fee: false,
        headers: [
          {text: "", value: "first_name", sortable: false},
          {text: "", value: "last_name", sortable: false},
          {text: "", value: "email", sortable: false},
          {text: "", value: "phone", sortable: false},
          {text: "", value: "is_admin", sortable: false},
          {text: "", value: "remove", sortable: false}
        ],
      };
    },
    methods: {
      addNewVendor: function () {
        this.users.push({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          is_admin: false,
        });
      },
      async submit() {
        const self = this;
        const valid = await this.$refs.validator.validate();
        if (valid) {
          self.$store
            .dispatch("Vendor_users_add_user/add_users", self.users)
            .then(async (errorsCounter) => {
              if (errorsCounter === 0) {
                self.show_SuccessModal();
              } else {
                await this.$refs.validator.validate();
                for (let i = 0; i < self.users.length; i++) {
                  if (self.users[i].error === '') {
                    self.users.splice(i, 1);
                  }
                }
              }
            })
            .catch(function (error) {
              console.error(error);
            });

        }
      },
      show_DeclinedModal() {
        this.showDeclinedModal = true;
      },
      hideDeclinedModal() {
        this.showDeclinedModal = false;
      }, show_SuccessModal() {
        this.showSuccessModal = true;
      },
      hideSuccessModal() {
        this.showSuccessModal = false;
      },
      removeItem(a) {
        this.users.splice(this.users.indexOf(a), 1);
      }
    },
  };
</script>

<style scoped lang="scss">

  .additional-info {
    background-color: #FBFBFB
  }

  .additional-info span.label {
    color: #061d47 !important;
    font-size: 17px !important;
    font-weight: bold !important;
  }

  .data-info {
    width: 24%;
  }

  .alert-value-font {
    color: #4565AB;
    font-size: 18px;
  }

  @media (max-width: 960px) {
    .data-info {
      width: 100%;
    }
  }
</style>
